<template>
    <div class="pt-2">
        <alert class="bg-red-50">
            <template #icon>
                <!--<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
                <!--    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" />-->
                <!--</svg>-->
                <svg class="w-5 h-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
            </template>
            <template #text>
                <div v-if="hasDefaultSlot" class="text-red-600"><slot></slot></div>
                <p v-if="!hasDefaultSlot" class="text-red-600">{{ text }}</p>
            </template>
            <template #link>
                <slot name="link"></slot>
            </template>
        </alert>
    </div>
</template>

<script>
import Alert from "./Alert"

export default {
    components: { Alert },

    props: ["alert"],

    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default
        },
        text() {
            if (!this.alert) return null
            return this.alert.success
        },
    },
}
</script>
